import { render } from "./createPost.vue?vue&type=template&id=0a36c666&scoped=true"
import script from "./createPost.vue?vue&type=script&lang=js"
export * from "./createPost.vue?vue&type=script&lang=js"

import "./createPost.vue?vue&type=style&index=0&id=0a36c666&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a36c666"]])

export default __exports__